













































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'incomeAndExpensesDetailTable'
})
export default class IncomeAndExpensesDetailTable extends Vue {
  @Prop({ default: () => {} }) public tableDetail: any
  @Prop({ default: '' }) public classNameSelf: string
  @Prop({ default: () => {} }) public reportFormSubjectAnalyzeDetail: any
  @Prop({ default: () => {} }) public schoolBaseInfo: any

  elPopoverSubjectShow (subjectCode) {
    // this.$emit('elPopoverSubjectShow', subjectCode)
  }
}
